export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9010.97caa958.jpg";